import { Avatar } from '@otter-ai/den-components';
import { useTranslations } from 'next-intl';

export function Title({
  invitorFirstName,
  invitorAvatarUrl,
}: {
  invitorFirstName: string;
  invitorAvatarUrl: string | null;
}) {
  const t = useTranslations('referrals');
  return (
    <div className="flex flex-col justify-center items-center space-y-2 pb-2">
      <Avatar imageUrl={invitorAvatarUrl} size="md" name={invitorFirstName} />
      <div className="text-xl font-semibold text-default text-center">
        {t('title', { invitorFirstName })}
      </div>
      <div className="text-sm text-subtle text-center">{t('description')}</div>
    </div>
  );
}
